module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-alert', {
    attrs: {
      "color": "error",
      "icon": "warning",
      "value": "true"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.mensagem) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ded0ac3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFound.vue
// module id = 379
// module chunks = 1